import { render, staticRenderFns } from "./RobotElectricity.vue?vue&type=template&id=0062e540&scoped=true&"
import script from "./RobotElectricity.vue?vue&type=script&lang=js&"
export * from "./RobotElectricity.vue?vue&type=script&lang=js&"
import style0 from "./RobotElectricity.vue?vue&type=style&index=0&id=0062e540&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062e540",
  null
  
)

export default component.exports